<template>
  <!-- 参标信息 -->
  <div class="shop-Product">
    <div class="Message-box">
      <p class="title">需求标题：</p>
      <p class="content">本公司需要设计LOGO</p>
    </div>
    <div class="Message-box">
      <p class="title">需求类型：</p>
      <p class="content">LOGO设计</p>
    </div>
    <div class="Message-box">
      <p class="title">需求描述：</p>
      <p class="content">
        国际物流行业，需求轻微修改logo中英文字体设计，目前原有logo寓意是国际物流面向全球运输yc字母组成环绕地
      </p>
    </div>
    <div class="Message-box">
      <p class="title">金额方式：</p>
      <p class="content">招标金额 依据招标报价</p>
    </div>
    <div class="Message-box">
      <p class="title">职位技能：</p>
      <p class="inline-p">UI设计</p>
      <p class="title">经验要求：</p>
      <p class="inline-p">UI设计</p>
      <p class="title">可参与地区：</p>
      <p class="inline-p">河南 南阳</p>
      <p class="title">可参与人数：</p>
      <p class="inline-p">20人</p>
    </div>
    <div class="Message-box">
      <p class="title">需求截止时间：</p>
      <p class="inline-p">2024年11月12日</p>
      <p class="title">招标截止时间：</p>
      <p class="inline-p">2024年12月31日</p>
    </div>
    <div class="Message-box">
      <p class="title">是否开发票：</p>
      <p class="content">不开发票</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
.shop-Product {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
}
// 招标信息div
.Message-box {
  width: 90%;
  height: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  display: flex;
  .title {
    min-width: 70px;
    font-size: 14px;
    color: #666666;
  }
  .content {
    flex: 1;
    color: #333333;
  }
  .inline-p {
    min-height: 50px;
    margin-right: 50px;
    color: #333333;
  }
}
</style>
